import { render, staticRenderFns } from "./BDXMatchPendingManagerExportButton.vue?vue&type=template&id=2a872d0c&scoped=true"
import script from "./BDXMatchPendingManagerExportButton.vue?vue&type=script&lang=js"
export * from "./BDXMatchPendingManagerExportButton.vue?vue&type=script&lang=js"
import style0 from "./BDXMatchPendingManagerExportButton.vue?vue&type=style&index=0&id=2a872d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a872d0c",
  null
  
)

export default component.exports